{
  "version": 1,
  "asset_id": "ffd614a5-d7ef-44d4-83c9-f916aafd5de5",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/ffd614a5-d7ef-44d4-83c9-f916aafd5de5/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/ffd614a5-d7ef-44d4-83c9-f916aafd5de5/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-768w.webp",
  "original_filename": "destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-768w.webp",
  "size": 45284,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:38:02Z"
}
